__webpack_require__.p = "https://bufflprodstorage.blob.core.windows.net/build-production/";